<template>
  <b-container class="m-2 mx-4">
    <b-row
      class="title-section"
      @mouseover="onHoverContinuous"
      @mouseleave="onLeaveContinuous"
      @click="selectContinuous()"
    >
      <p class="p-title-section">
        Continuous Studies
      </p>
    </b-row>
    <MutiOptionsSelection
      v-for="(study,index) in studyControllersCont"
      :key="index+'Cont'"
      :study="study"
      :listcontr="studyControllersCont"
      @removeElement="removeElementStudyCont"
    />
    <b-row class="text-center my-1">
      <b-button
        v-b-hover="handleAddHoverCont"
        variant="primary"
        size="sm"
        class="py-0"
        :disabled="studyControllersCont.length > 0 && studyControllersCont.every(ctrl=>ctrl.disabled)"
        @click="addStudyCont"
      >
        <b-icon
          v-if="isAddHoveredCont"
          aria-label="Add"
          icon="plus-square"
        />
        <b-icon
          v-else
          aria-label="Add"
          icon="plus-square-fill"
        />
      </b-button>
    </b-row>
    <b-row
      class="title-section"
      @mouseover="onHoverDiscrete"
      @mouseleave="onLeaveDiscrete"
      @click="selectDiscrete()"
    >
      <p class="p-title-section">
        Discrete Studies
      </p>
    </b-row>
    <MutiOptionsSelection
      v-for="(study,index) in studyControllersDisc"
      :key="index+'Disc'"
      :study="study"
      :listcontr="studyControllersDisc"
      @removeElement="removeElementStudyDisc"
    />
    <b-row class="text-center my-1">
      <b-button
        v-b-hover="handleAddHoverDisc"
        variant="primary"
        size="sm"
        class="py-0"
        :disabled="studyControllersDisc.length > 0 && studyControllersDisc.every(ctrl=>ctrl.disabled)"
        @click="addStudyDisc"
      >
        <b-icon
          v-if="isAddHoveredDisc"
          aria-label="Add"
          icon="plus-square"
        />
        <b-icon
          v-else
          aria-label="Add"
          icon="plus-square-fill"
        />
      </b-button>
    </b-row>
  </b-container>
</template>

<script>
import {studiesCtrl} from '@/assets/classes/multiOptionsCtllr.js'
import {PlotType,continuous_Study,discrete_Study} from '@/common/plotDefinitions.js'
import MutiOptionsSelection from './elements/MultiOptionsSelection'
import { mapActions, mapGetters } from 'vuex'

const contextRouteContinuousStudies='ReportViewer/Studies/General/ContinuousStudies'
const contextRouteDiscreteStudies='ReportViewer/Studies/General/DiscreteStudies'

export default {
  name: 'StudiesConfiguration',
  components:{
    MutiOptionsSelection
  },
  data() {
    return{
      isAddHoveredCont: false,
      isAddHoveredDisc: false,
      studyControllersCont:[],
      studyControllersDisc:[]
    }
  },
    computed: mapGetters([
        'getStudiesReportViewer'
    ]),
  mounted() {
    this.initializeController()
  },
  methods:{
    ...mapActions([
            'setContextOnHover',
            'setConfigReportModifiedReportViewer',
            'setContextFixElement'
        ]),
    handleAddHoverDisc(hovered) {//Handle the hover on the Add button
      this.isAddHoveredDisc = hovered
    },
    handleAddHoverCont(hovered) {//Handle the hover on the Add button
      this.isAddHoveredCont = hovered
    },
    addStudyCont(){//Handle the add study function.
      this.setConfigReportModifiedReportViewer()
      studiesCtrl.createNewStudy(this,this.studyControllersCont,continuous_Study) //Static function that add the new study in both arrays
    },
    addStudyDisc(){//Handle the add study function.
    this.setConfigReportModifiedReportViewer()
      studiesCtrl.createNewStudy(this,this.studyControllersDisc,discrete_Study) //Static function that add the new study in both arrays
    },
    initializeController(){ //Clear the controllers and initialize with the list of studies that comes from a higher level. It matches both lists
      this.studyControllersCont = []
      const studiesCont = this.getStudiesReportViewer.filter(study=>PlotType[study.base].type===continuous_Study)
      studiesCont.forEach(study=>studiesCtrl.recoverStudy(this,this.studyControllersCont,study,continuous_Study)) //Similar to Add study, but here it tries to recover the data
      this.studyControllersDisc = []
      const studiesDisc = this.getStudiesReportViewer.filter(study=>PlotType[study.base].type===discrete_Study)
      studiesDisc.forEach(study=>studiesCtrl.recoverStudy(this,this.studyControllersDisc,study,discrete_Study)) //Similar to Add study, but here it tries to recover the data
    },
    onHoverContinuous() {
      this.setContextOnHover(contextRouteContinuousStudies)
    },
    onLeaveContinuous(){
      this.setContextOnHover(null)
    },
    onHoverDiscrete() {
      this.setContextOnHover(contextRouteDiscreteStudies)
    },
    onLeaveDiscrete(){
      this.setContextOnHover(null)
    },
    selectContinuous(){
      this.setContextFixElement(contextRouteContinuousStudies)
    },
    selectDiscrete(){
      this.setContextFixElement(contextRouteDiscreteStudies)
    },
        removeElementStudyCont(indexStudyCtrl){
            this.studyControllersCont.splice(indexStudyCtrl, 1);
        },
        removeElementStudyDisc(indexStudyCtrl){
            this.studyControllersDisc.splice(indexStudyCtrl, 1);

        }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .btn:disabled{
    cursor:default;
  }
</style>
